import { fetchFromObject } from 'helpers/object';

export default {
  dataUI: state => field => fetchFromObject(state, field)
};
